import type {
  CustomerInfo as CustomerInfoCapacitor,
  PurchasesEntitlementInfo as EntitlementInfoCapacitor,
  PurchasesPackage as PackageCapacitor,
} from '@revenuecat/purchases-capacitor';
import type { Package as PackageJs } from '@revenuecat/purchases-js';

export enum PackageType {
  UNKNOWN = 'UNKNOWN',
  CUSTOM = 'CUSTOM',
  LIFETIME = 'LIFETIME',
  ANNUAL = 'ANNUAL',
  SIX_MONTH = 'SIX_MONTH',
  THREE_MONTH = 'THREE_MONTH',
  TWO_MONTH = 'TWO_MONTH',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}

export interface Package {
  // Some functions require the original package object
  rcPackage: PackageCapacitor | PackageJs;

  // Keep capacitor-compatible fields
  // In case capacitor adds built-in web support in the future

  identifier: PackageCapacitor['identifier'];
  packageType: PackageType;
  product: {
    identifier: PackageCapacitor['product']['identifier'];
    priceString: PackageCapacitor['product']['priceString'];
    pricePerWeek: PackageCapacitor['product']['pricePerWeek'];
    pricePerWeekString: PackageCapacitor['product']['pricePerWeekString'];
    pricePerMonth: PackageCapacitor['product']['pricePerMonth'];
    pricePerMonthString: PackageCapacitor['product']['pricePerMonthString'];
  };
}

export interface EntitlementInfo {
  productIdentifier: EntitlementInfoCapacitor['productIdentifier'];
  expirationDate: EntitlementInfoCapacitor['expirationDate'];
  willRenew: EntitlementInfoCapacitor['willRenew'];
  store: EntitlementInfoCapacitor['store'];
}

export interface CustomerInfo {
  managementURL: CustomerInfoCapacitor['managementURL'];
  entitlements: {
    active: Record<string, EntitlementInfo>;
  };
}
